export default "__VITE_ASSET__wHQRfQTn__"